import { FC } from "react";
import { css } from "@emotion/react";
import { Button, Font } from "@moneyforward/mfx_biz_react_components";
import { PageTitle } from "@/components/molecules";
import { PlanCancellationStepper } from "@/components/atoms/PlanCancellationStepper";
import Spacer from "@/components/atoms/utilities/Spacer";
import { TermBoxPlanCancel } from "@/components/molecules/termbox/TermBoxPlanCancel";

type Props = {
  onClickProceed: () => void;
  onClickCancel: () => void;
};

export const PlanCancelPreprocessForm: FC<Props> = (props) => {
  return (
    <div css={container}>
      <PageTitle
        mainTitle={"解約手続き"}
        subTitle={
          <Font variant="l">
            Mikatano シリーズをご利用いただきありがとうございます。
            <br />
            今後のサービス向上のため、アンケートにご協力よろしくお願いいたします。
            <br />
            アンケートへ回答いただいた後に、解約手続きに移ります。
          </Font>
        }
      >
        <Spacer size={32} />
        <PlanCancellationStepper step={1} />
      </PageTitle>
      <TermBoxPlanCancel />
      <div css={buttonGroup}>
        <Button variant="secondary" onClick={props.onClickCancel}>
          キャンセル
        </Button>
        <Button variant="primary" onClick={props.onClickProceed}>
          アンケート回答
        </Button>
      </div>
    </div>
  );
};

const container = css({
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: "48px",
  maxWidth: "640px",
});

const buttonGroup = css({
  display: "flex",
  justifyContent: "flex-end",
  gap: "16px",
});
